<template>
	<div class="checkout-wrapper" ref="checkoutWrapper">
		<div class="navbar-white">
			<Navbar :backButton="false" :logoSrc="$logoSrc" />
		</div>
		<div class="checkout-details-container">
			<GuestContactForm
                class="guest-contact-form"
				ref="guestContactForm"
				:requiresPayment="requiresPayment"
				@toggleLoader="toggleLoader"
			/>
			<CheckoutAdditionalInfo />
            <div class="guest-checkout-bottom">
                <button
                    v-if="requiresPayment || checkoutRequirementsNotMet"
                    class="button button-primary button-checkout"
                    :disabled="checkoutRequirementsNotMet"
                    @click="checkoutClicked"
                >
                    {{ checkoutButtonText }}
                </button>
                <button
                    v-else
                    class="button button-primary button-checkout"
                    @click="placeOrderClicked"
                >
                    Place Order
                </button>

                <div class="terms-links">
                    <a :href="tosUrl" target="_blank">Terms of Service</a>
                    <span class="terms-links-seperator">|</span>
                    <a :href="privacyUrl" target="_blank">Privacy Policy</a>
                </div>
            </div>
		</div>
	</div>
</template>

<style scoped>
.checkout-wrapper {
    height: 100%;
    padding-bottom: 60px;
	overflow: scroll;
	background: var(--sk-grey-bg);
}

.checkout-details-container {
	max-width: 500px;
	margin: 0 auto;
	padding: 0 15px;
}

.navbar-white {
	margin-bottom: 25px;
}

.button-checkout {
    width: calc(100% - 20px);
	margin: 0 auto;
	max-width: 400px;
}

.terms-links {
	display: flex;
	flex: 1;
	align-items: flex-end;
	justify-content: center;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 35px;
}

.terms-links,
.terms-links a {
	color: var(--sk-grey2);
	font-size: 10px;
    text-align: center;
}

.terms-links-seperator {
	color: var(--sk-grey2);
	font-size: 10px;
	padding: 0 3px;
}

.checkout-details-container >>> .checkout-additional-info {
	padding: 0;
}

.guest-contact-form {
    margin-bottom: 30px;
}

.guest-checkout-bottom {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    background: var(--sk-grey-bg);
}
</style>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import checkoutMixin from "@/mixins/checkout-mixin"
import loaderMixin from "@/mixins/loader-mixin"
import Navbar from "@/components/navbars/Navbar.vue"
import GuestContactForm from "@/components/checkout/GuestContactForm.vue"
import CheckoutAdditionalInfo from "@/components/checkout/CheckoutAdditionalInfo.vue"

export default {
	name: "GuestCheckout",
	mixins: [currencyFilterMixin, loaderMixin, checkoutMixin],
	components: {
		Navbar,
		CheckoutAdditionalInfo,
		GuestContactForm
	},
	computed: {
		minimumOrderAmount() {
			return this.$store.getters.minimumOrderAmount
		},
		requireFoodProducts() {
			return this.$store.getters.cartHasOnlyAlcohol
		},
		requiresPayment: function () {
			return this.$store.getters.totalCheckoutPrice > 0
		},
		checkoutRequirementsNotMet() {
			return (
				this.$store.getters.itemsInCartCount <= 0 ||
				this.minimumNotMet ||
				this.requireFoodProducts
			)
		},
		checkoutButtonText() {
			if (this.minimumNotMet) {
				const requiredAmount = parseInt(
					this.minimumOrderAmount - this.$store.getters.price
				).toFixed(2)
				return "Add $" + requiredAmount + " to Continue"
			} else if (this.requireFoodProducts) {
				return "Add at least one non-alcoholic product."
			}
			return (
				"Place Order: " +
				this.$options.filters.currency(
					this.$store.getters.totalCheckoutPrice
				)
			)
		},
		tosUrl() {
			return "/" + this.$route.params.slug + "/terms_of_use"
		},
		privacyUrl() {
			return "/" + this.$route.params.slug + "/privacy"
		}
	},
	methods: {
		checkoutClicked() {
            this.$refs.guestContactForm.checkout()
		},
		placeOrderClicked() {
			if (!this.$store.state.inPurchaseState) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Click Purchase",
					data: {
						type: "Voucher"
					}
				})
				this.toggleLoader(true)
				this.$store.dispatch("processVoucherOrder")
			}
		}
	},
	created: function () {
		window.scroll({ top: 0 })
	}
}
</script>